exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-container[data-v-484c2411] {\n  max-width: 620px;\n}\n.modal-body[data-v-484c2411] {\n  padding-bottom: 0;\n  padding-top: 10px;\n}\n", ""]);

// exports
